export default __webpack_public_path__ + "static/media/loading.95f0ee82.gif";